import React from 'react';

interface AccessDeniedProps {
  message?: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ 
  message = 'No tienes permisos para acceder a esta sección' 
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4">
      <div className="text-red-500 mb-4">
      {/*   <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg> */}
      </div>
    {/*   <h2 className="text-2xl font-bold text-gray-800 mb-2">Acceso Denegado</h2> */}
      <p className="text-gray-600 text-center"><b>CARGANDO...</b></p>
    </div>
  );
};

export default AccessDenied; 